/* eslint-disable extra-rules/no-commented-out-code */
export const LimitlessBrand = {
  typography: {
    heading: {
      h1: {
        largeScreen: {
          //styleName: Header/Large/h1;
          fontFamily: "Work Sans",
          fontSize: 102,
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: -1.5
        },
        smallScreen: {
          //styleName: Header/Small/h1;
          fontFamily: "Work Sans",
          fontSize: 36,
          fontWeight: 400,
          lineHeight: 1.2,
          letterSpacing: 0.25
        }
      },
      h2: {
        largeScreen: {
          //styleName: Header/Large/h2;
          fontFamily: "Work Sans",
          fontSize: 64,
          fontWeight: 300,
          lineHeight: 1.2,
          letterSpacing: -0.5
        },
        smallScreen: {
          //styleName: Header/Small/h2;
          fontFamily: "Work Sans",
          fontSize: 25,
          fontWeight: 400,
          lineHeight: 1.2,
          letterSpacing: 0
        }
      },
      h3: {
        largeScreen: {
          //styleName: Header/Large/h3;
          fontFamily: "Roboto",
          fontSize: 48,
          fontWeight: 400,
          lineHeight: 1.17,
          letterSpacing: "0em"
        },
        smallScreen: {
          //styleName: Header/Small/h3;
          fontFamily: "Roboto",
          fontSize: 31,
          fontWeight: 400,
          lineHeight: 1.2,
          letterSpacing: 0.25
        }
      },
      h4: {
        largeScreen: {
          //styleName: Header/Large/h4;
          fontFamily: "Roboto",
          fontSize: 34,
          fontWeight: 400,
          lineHeight: 1.2,
          letterSpacing: 0.25
        },
        smallScreen: {
          //styleName: Header/Small/h4;
          fontFamily: "Roboto",
          fontSize: 24,
          fontWeight: 400,
          lineHeight: 1.33,
          letterSpacing: "0em"
        }
      },
      h5: {
        largeScreen: {
          //styleName: Header/Large/h5;
          fontFamily: "Roboto",
          fontSize: 24,
          fontWeight: 400,
          lineHeight: 1.208,
          letterSpacing: "0em"
        },
        smallScreen: {
          //styleName: Header/Small/h5;
          fontFamily: "Roboto",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 0.15000000596046448
        }
      },
      h6: {
        largeScreen: {
          //styleName: Header/Large/h6;
          fontFamily: "Roboto",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: 1.4,
          letterSpacing: 0.15000000596046448
        },
        smallScreen: {
          //styleName: Header/Small/h6;
          fontFamily: "Roboto",
          fontSize: 16,
          fontWeight: 500,
          lineHeight: 1.5,
          letterSpacing: 0.20000000298023224
        }
      }
    },
    body: {
      subtitle1: {
        //styleName: Subtitle/Subtitle 1;
        fontFamily: "Roboto",
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: 0.15000000596046448
      },
      subtitle2: {
        //styleName: Subtitle/Subtitle2;
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.5,
        letterSpacing: 0.10000000149011612
      },
      body1: {
        //styleName: Body/Body1;
        fontFamily: "Roboto",
        fontSize: 16,
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: 0.5
      },
      body2: {
        //styleName: Body/Body2;
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: 0.25
      },
      button: {
        //styleName: Body/Button;
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.14,
        letterSpacing: 1.0499999523162842
      },
      textButton: {
        //styleName: Body/Text Button;
        fontFamily: "Roboto",
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.71,
        letterSpacing: 0.20000000298023224
      },
      caption: {
        //styleName: Body/Caption;
        fontFamily: "Roboto",
        fontSize: 12,
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: 0.4000000059604645
      },
      overline: {
        //styleName: Body/Overline;
        fontFamily: "Roboto",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 1.6,
        letterSpacing: 1.5
      }
    }
  }
};